import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header({ isLoaded }) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
    const location = useLocation();
    const isMainPage = location.pathname === '/';

    const navigationItems = [
        { name: 'About Us', path: '/#about-us' },
        { name: 'Services', path: '/#our-service' },
        { name: 'Work', path: '/#work' },
        { name: 'Expertise', path: '/services' }
    ];

    return (
        <>
            <header className={`transition-all duration-1000 ease-out relative z-50 ${isLoaded ? 'translate-y-0 opacity-100' : '-translate-y-8 opacity-0'}`}>
                <div className="px-6 lg:px-12 pt-8 lg:pt-12">
                    <div className="bg-white rounded-full px-6 md:px-10 py-4 md:py-5 flex items-center justify-between shadow-xl relative z-50">
                        {/* Logo */}
                        <Link
                            to="/"
                            className="flex items-center cursor-pointer"
                        >
                            <img
                                src="/images/zenruva-logo.png"
                                alt="Zenruva"
                                className="h-10 md:h-12 w-auto object-contain"
                            />
                        </Link>

                        {/* Desktop Navigation */}
                        <nav className="hidden md:flex items-center gap-8 lg:gap-12">
                            {navigationItems.map((item, idx) => (
                                <Link
                                    key={item.name}
                                    to={item.path}
                                    className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-semibold relative group text-lg lg:text-xl"
                                    style={{
                                        transitionDelay: `${idx * 100}ms`,
                                        opacity: isLoaded ? 1 : 0,
                                        transform: isLoaded ? 'translateY(0)' : 'translateY(-10px)'
                                    }}
                                >
                                    {item.name}
                                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full" />
                                </Link>
                            ))}
                        </nav>

                        {/* CTA Button & Mobile Toggle */}
                        <div className="flex items-center gap-4">
                            <a href="#book-call" className="hidden md:block bg-blue-600 hover:bg-blue-700 text-white px-6 md:px-8 py-2.5 md:py-3 rounded-full font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg active:scale-95 text-sm md:text-base cursor-pointer">
                                Book a Call
                            </a>

                            {/* Hamburger Button */}
                            <button
                                className="md:hidden text-gray-800 focus:outline-none"
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            >
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    {isMobileMenuOpen ? (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    ) : (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                    )}
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
                <div className="fixed inset-0 z-[100] md:hidden flex items-center justify-center p-6">
                    {/* Backdrop with blur */}
                    <div 
                        className="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity duration-300"
                        onClick={() => setIsMobileMenuOpen(false)}
                    />
                    
                    {/* Menu Card */}
                    <div className="relative bg-white w-full max-w-[320px] rounded-[32px] p-8 shadow-2xl flex flex-col items-center gap-8 animate-menu-in">
                        {/* Header within card */}
                        <div className="w-full h-12 flex items-center justify-between">
                            <img
                                src="/images/zenruva-logo.png"
                                alt="Zenruva"
                                className="h-8 w-auto object-contain"
                            />
                            <button
                                className="text-gray-800 focus:outline-none"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Navigation Links */}
                        <nav className="flex flex-col items-center gap-6">
                            {navigationItems.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.path}
                                    onClick={() => setIsMobileMenuOpen(false)}
                                    className="text-gray-900 text-xl font-bold hover:text-blue-600 transition-colors"
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </nav>

                        {/* CTA Link */}
                        <a
                            href="#book-call"
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="bg-blue-600 text-white w-full py-4 rounded-2xl font-bold text-center shadow-lg active:scale-95 transition-transform"
                        >
                            Book a Call
                        </a>
                    </div>
                </div>
            )}
        </>
    );
}